/**
 * Classe base para todos os fields.
 * @author: Adalto Junior
 * Date: 20/09/13
 * Time: 11:47
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.TagFilter = (function () {

    function TagFilter () {

        Monet.UI.Fields.PickListMultiselectFilter.apply(this, arguments);

        this.getValue = function () {
            var value = null;

            if (this._checkedIds && this._checkedIds.length) {
                value = this._checkedIds;
            }

            return value;
        };

        this.customRequestItems = function (context) {

            return function () {
                var ajax = new Monet.Ajax();
                ajax.url = 'Tag/restrictions?criteria={"filters":["*"]}';
                ajax.method = 'POST';
                ajax.data = '{"criteriaChain":[{"or":[{"attr":"tagType","eq":"' + this.entity.toUpperCase() + '"}]}]}';
                ajax.success = function (data) {
                    context.successOfRequestData(data);
                };

                ajax.send();
            };

        }(this);

    }

    return TagFilter;

}());